import React, { JSX } from "react";
import { Tooltip, IconButton } from "@mui/material";
import FingerprintIcon from "@mui/icons-material/Fingerprint";

interface Props {
  onClick: () => void;
}

const SettingsButton = ({ onClick }: Props): JSX.Element => (
  <Tooltip arrow title="Search by Fingerprint">
    <IconButton
      onClick={onClick}
      data-testmation="searchByFpButton"
      sx={{
        width: 32,
        height: 32,
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 1
      }}
    >
      <FingerprintIcon color="action" />
    </IconButton>
  </Tooltip>
);

export default SettingsButton;
